import { Dispatch, RefObject, SetStateAction } from "react";

import { faPlay, faStop } from "@fortawesome/pro-solid-svg-icons";

import { isValidUrl } from "@/utils/isValidUrl";

import { Icon } from "@/components";

import { IStageContentInfo } from "../../Courses/constants/emptyCourseScenario";
import { FileTypes } from "../../Courses/enums/FileTypes.enum";

export const renderContent = (
	t: (key: string) => string,
	ts: (key: string) => string,
	contentInfo: IStageContentInfo,
	audioRef?: RefObject<HTMLAudioElement | null>,
	isAudioPlaying?: boolean,
	setIsAudioPlaying?: Dispatch<SetStateAction<boolean>>
) => {
	if (!contentInfo) {
		return <></>;
	}

	if (!isValidUrl(contentInfo.content)) {
		return contentInfo.content;
	}

	switch (contentInfo.contentType?.toUpperCase()) {
		case FileTypes.Image:
			return (
				<img
					key={contentInfo.content}
					alt="Content"
					className="block mx-auto w-full h-full max-w-screen-w max-h-[80vh] object-contain"
					src={contentInfo.content}
				/>
			);
		case FileTypes.Video:
			return (
				<video key={contentInfo.content} controls className="block mx-auto w-auto">
					<source src={contentInfo.content} type="video/mp4" />
					{t("basics.not-support-tag")}
				</video>
			);
		case FileTypes.Audio:
			return (
				<div key={contentInfo.content} className="mt-4 flex flex-row items-center justify-center">
					{contentInfo?.avatar?.url ? (
						<div
							className="relative group"
							onClick={() => {
								const audio = audioRef?.current;

								if (!audio) {
									return;
								}

								if (!audio.paused) {
									audio.pause();
								} else {
									audio.play();
								}
							}}
						>
							<div className="border-2 border-gray-200 bg-brand-white hover:cursor-pointer rounded-lg px-4 py-2 flex justify-center transition delay-200 opacity-20 group-hover:opacity-100 absolute bottom-0  -translate-y-1/3 right-1/2 translate-x-1/2 z-10 ">
								<Icon
									icon={isAudioPlaying ? faStop : faPlay}
									// className={`${contentInfo.avatar?.url ? "relative" : ""}`}
								/>
							</div>

							<img
								className={`hover:cursor-pointer w-auto h-[200px]`}
								src={`${contentInfo?.avatar?.url}`}
							/>
						</div>
					) : (
						""
					)}
					<audio
						key={contentInfo.content}
						ref={audioRef}
						controls
						className={contentInfo?.avatar?.url ? "hidden" : "block mx-auto w-full max-w-xl"}
						onEnded={() => {
							setIsAudioPlaying?.(false);
						}}
						onPause={() => {
							setIsAudioPlaying?.(false);
						}}
						onPlaying={() => {
							setIsAudioPlaying?.(true);
						}}
					>
						<source src={contentInfo.content} type="audio/mpeg" />
						{t("basics.not-support-tag")}
					</audio>
				</div>
			);
		default:
			return <p key={contentInfo.content}>{ts("unsupported-content-type")}</p>;
	}
};
